import React, { useEffect, useState } from "react";
import { object, array, bool, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Organism1 from "./Organism1";
import Organism2 from "./Organism2";
import Organism3 from "./Organism3";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import { getSlug, getDeviceType } from "../../utils/utils";
import DfpAd from "../../dfp-ad";

import "./sixStories1WidgetWithPoll.m.css";

const SixStories1WidgetWithPoll = ({
  collection,
  sections,
  isSectionComponent = false,
  firstStoriesSet,
  widgetUrl = null,
  publisherAttributes,
  domainSlug
}) => {
  const [deviceType, setDeviceType] = useState(null);
  const [isTab, setIsTab] = useState(false);
  let collectionItems = [];

  if (!isSectionComponent) {
    collectionItems =
      collection &&
      collection.items &&
      collection.items.length > 0 &&
      collection.items.filter(item => item.type === "collection").slice(0, 2);
  }
  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const firstCollection = collectionItems && collectionItems.length > 0 ? collectionItems[0] : null;
  const secondCollection = collectionItems && collectionItems.length > 1 ? collectionItems[1] : null;

  useEffect(() => {
    setDeviceType(getDeviceType());
    setIsTab(global.deviceWidth > 875);
  }, []);

  const collectionSlug = getSlug(collection, sections, domainSlug);
  const stories =
    firstCollection &&
    firstCollection.items &&
    firstCollection.items.length > 0 &&
    firstCollection.items.filter(item => item.type === "story");
  const storiesSet = stories && stories.length ? stories.slice(0, 6) : null;
  const storyList = isSectionComponent ? firstStoriesSet : storiesSet;

  if (!(storyList && storyList.length)) {
    return null;
  }

  const getStoriesLength = type => {
    if (type === "organism1") {
      if (deviceType === "tablet") {
        return 4;
      } else if (deviceType === "mobile") {
        return 6;
      }

      return 2;
    } else {
      if (deviceType === "tablet") {
        return 6;
      }
      return 6;
    }
  };

  const widgetPollingView = () => (
    <div styleName="widget-polling">
      {isSectionComponent ? (
        <div styleName="side-ad">
          <DfpAd
            adtype={publisherAttributes.lang === "en" ? "EnPalo_ROS_336x280_R1" : "News_336x280_R1"}
            collectionSlug={collectionSlug}
          />
          {widgetUrl && <iframe src={widgetUrl} styleName="widget-iframe"></iframe>}
        </div>
      ) : secondCollection ? (
        <Organism3 collection={secondCollection} sections={sections} domainSlug={domainSlug} />
      ) : null}
    </div>
  );

  return (
    <div styleName="base" className="six-stories-1widget-poll" data-testid="six-story-widget">
      {showCollectionName && (
        <CollectionTitleWithArrow collectionName={collection.name} collectionSlug={collectionSlug} updatedFont={true} />
      )}

      {/* Row */}
      <div styleName="wrapper">
        {/* Column 1 */}
        <Organism1 stories={storyList.slice(0, getStoriesLength("organism1"))} updatedFont={true} />

        {/* Column 2 */}
        <div styleName="story-widget-view">
          {isTab && (
            <Organism2
              stories={storyList.slice(getStoriesLength("organism1"), getStoriesLength("organism2"))}
              updatedFont={true}
            />
          )}
          {widgetPollingView()}
        </div>
      </div>
    </div>
  );
};

SixStories1WidgetWithPoll.propTypes = {
  collection: object,
  sections: array,
  isSectionComponent: bool,
  firstStoriesSet: array,
  widgetUrl: string,
  publisherAttributes: object,
  domainSlug: string
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], []),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
    domainSlug: get(state, ["qt", "config", "domainSlug"], "")
  };
};

export default connect(mapStateToProps, null)(SixStories1WidgetWithPoll);
